import type { components } from '@app/api/types';

export type ApprovalEvidence = components['schemas']['ApprovalDecisionEvidence'];
export type EvidenceChange = ApprovalEvidence['changes'][number];
export type WithApprovalEvidence = Pick<components['schemas']['Approval'], 'decision_evidence'>;

/** These are the saved rule's matches, not a re-evaluation against current configuration. */
export function savedRuleRequires(evidence: ApprovalEvidence, change: EvidenceChange): boolean {
  if (!evidence.environment?.selectable_for_identity) return false;
  const rule = evidence.rules.find((item) => item.event === change.event);
  if (!rule) return false;
  if (rule.mode === 'never') return false;
  return (
    rule.mode === 'always' ||
    change.unknown ||
    change.classes.some((value) => rule.classes.includes(value))
  );
}
export function savedChange(
  evidence: ApprovalEvidence | undefined,
  position: number,
  capability: string,
): EvidenceChange | undefined {
  if (evidence?.version !== 1) return undefined;
  return evidence.changes.find(
    (change) => change.position === position && change.capability === capability,
  );
}
